import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import {DefaultTheme} from "./design";
import {Reset} from "styled-reset";
import {createGlobalStyle, ThemeProvider} from "styled-components";
import BGIcon from "./assets/imgs/bg-squares.svg";
import PaymentPageDetails from "./routes/paymentpage/components/PaymentPageDetails";
import App from "./App";
import { Provider } from 'react-redux'
import store from './redux/index';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

const GlobalStyle = createGlobalStyle`
  body {
    position: relative;
    font-family: Open Sans;
    font-size: 14px;
    margin: 0px;
    padding: 0px;
    background-color: #F7F7F7;
    overflow-y: auto;
    overflow-x: hidden;
    background-image: url("${BGIcon}");
     background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
  }
`;

const PaymentPage = (props) => (
  <ThemeProvider theme={DefaultTheme}>
    <Reset />
    <GlobalStyle />
    <PaymentPageDetails {...props}/>
  </ThemeProvider>
);

export default PaymentPage;
